import React, { useEffect, useState } from 'react';

export default function AdminAuthDebugPage() {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);
        const res = await fetch('/api/users/me', { credentials: 'include' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        console.log('Auth:', json);
        setData(json);
      } catch (e: any) {
        console.error('Error loading auth data:', e);
        setError(e?.message || 'Error loading data');
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (loading) return <div className="p-4">Loading…</div>;
  if (error) return <div className="p-4 text-red-600">Error loading data</div>;

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">Auth (Debug)</h1>
      <pre className="text-sm bg-gray-100 p-3 rounded overflow-auto">{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}
